import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import company from "static/image/onboarding/company.png";
import { BottomNextButton } from "components/common/BottomNextButton";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../../../../api";
import useRefetchTaskList from "../../../../hooks/useRefetchTaskList";
import useIsInappWebview from "../../../../hooks/useIsInappWebview";
import useClose from "../../../../hooks/useClose";
import { useRecoilValue } from "recoil";
import { patientAtom } from "../../../../recoil/patientAtom";

export default function Goal_PS_12() {
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const refetchTaskList = useRefetchTaskList();
  const isInappWebview = useIsInappWebview();

  const patient = useRecoilValue(patientAtom);
  const close = useClose();
  const refetchTaskListAndOpenSidebar = () => {
    refetchTaskList();
  };

  const { mutate: activityDone, isLoading: isActivityDoneLoading } =
    useMutation(
      async () => {
        return taskApi.done(`0-10-A:${patient?.patientId}`);
      },
      {
        onSuccess: () => {
          setTimeout(() => {
            refetchTaskListAndOpenSidebar();
          }, 1000);
          close();
        },
        onError: (error) => {
          console.error("Activity done failed:", error);
        },
      }
    );

  const handleNext = () => {
    activityDone();

    // done
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          {"공신력 있는 기관들과 함께합니다."}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {
            "디스턴싱은 유수의 병원, 대학, 기업들과의 협업, 투자 및 연구로 인정을 받고 있습니다."
          }
        </CustomTypography>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={company}
            alt={"onboarding"}
            style={{
              maxWidth: "300px",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"마치기"}
        loading={isActivityDoneLoading}
        highlightBackground={true}
      />
    </Box>
  );
}
